/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BatchVerifyUnipassPersonReqVo,
  HtmlWrapperVo,
  ResponseCargCsclPrgsInfoQryRtnVo,
  ResponseDomeggookGoodsVo,
  ResponseKrAddressResultVo,
  ResponseListTaoBaoCopyProductVo,
  ResponseListVerifyUnipassPersonResVo,
  ResponseTaoBaoProductVo,
  ResponseVerifyUnipassPersonResVo,
} from '../models/index';
import {
    BatchVerifyUnipassPersonReqVoFromJSON,
    BatchVerifyUnipassPersonReqVoToJSON,
    HtmlWrapperVoFromJSON,
    HtmlWrapperVoToJSON,
    ResponseCargCsclPrgsInfoQryRtnVoFromJSON,
    ResponseCargCsclPrgsInfoQryRtnVoToJSON,
    ResponseDomeggookGoodsVoFromJSON,
    ResponseDomeggookGoodsVoToJSON,
    ResponseKrAddressResultVoFromJSON,
    ResponseKrAddressResultVoToJSON,
    ResponseListTaoBaoCopyProductVoFromJSON,
    ResponseListTaoBaoCopyProductVoToJSON,
    ResponseListVerifyUnipassPersonResVoFromJSON,
    ResponseListVerifyUnipassPersonResVoToJSON,
    ResponseTaoBaoProductVoFromJSON,
    ResponseTaoBaoProductVoToJSON,
    ResponseVerifyUnipassPersonResVoFromJSON,
    ResponseVerifyUnipassPersonResVoToJSON,
} from '../models/index';

export interface ThirdPartProductBatchVerifyUnipassPersonPostRequest {
    batchVerifyUnipassPersonReqVo?: Array<BatchVerifyUnipassPersonReqVo>;
}

export interface ThirdPartProductCargoQueryGetRequest {
    blNo: string;
}

export interface ThirdPartProductGetDomeggookItemGetRequest {
    originalUrl: string;
}

export interface ThirdPartProductGetKrAddressGetRequest {
    keyword: string;
}

export interface ThirdPartProductGetTaoBao1688ItemGetRequest {
    originalUrl: string;
}

export interface ThirdPartProductGetTaoBaoCopyOrderItemPostRequest {
    htmlWrapperVo?: HtmlWrapperVo;
}

export interface ThirdPartProductGetTaoBaoCopyShoppingCartHtmlPostRequest {
    htmlWrapperVo?: HtmlWrapperVo;
}

export interface ThirdPartProductGetTaoBaoItemGetRequest {
    originalUrl: string;
}

export interface ThirdPartProductVerifyUnipassPersonGetRequest {
    persEcm: string;
    pltxNm: string;
    cralTelno: string;
    zip: string;
}

/**
 * 
 */
export class ThirdPartProductControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 批量验证个人通关号
     */
    async thirdPartProductBatchVerifyUnipassPersonPostRaw(requestParameters: ThirdPartProductBatchVerifyUnipassPersonPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListVerifyUnipassPersonResVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/thirdPartProduct/batchVerifyUnipassPerson`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['batchVerifyUnipassPersonReqVo']!.map(BatchVerifyUnipassPersonReqVoToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListVerifyUnipassPersonResVoFromJSON(jsonValue));
    }

    /**
     * 
     * 批量验证个人通关号
     */
    async thirdPartProductBatchVerifyUnipassPersonPost(requestParameters: ThirdPartProductBatchVerifyUnipassPersonPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListVerifyUnipassPersonResVo> {
        const response = await this.thirdPartProductBatchVerifyUnipassPersonPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 通关查询
     */
    async thirdPartProductCargoQueryGetRaw(requestParameters: ThirdPartProductCargoQueryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseCargCsclPrgsInfoQryRtnVo>> {
        if (requestParameters['blNo'] == null) {
            throw new runtime.RequiredError(
                'blNo',
                'Required parameter "blNo" was null or undefined when calling thirdPartProductCargoQueryGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['blNo'] != null) {
            queryParameters['blNo'] = requestParameters['blNo'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/thirdPartProduct/cargoQuery`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseCargCsclPrgsInfoQryRtnVoFromJSON(jsonValue));
    }

    /**
     * 
     * 通关查询
     */
    async thirdPartProductCargoQueryGet(requestParameters: ThirdPartProductCargoQueryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseCargCsclPrgsInfoQryRtnVo> {
        const response = await this.thirdPartProductCargoQueryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 用url获取domeggook商品，无规格选项的商品（二手/一口价）skus返回单一默认SKU（价格库存取详情页）
     */
    async thirdPartProductGetDomeggookItemGetRaw(requestParameters: ThirdPartProductGetDomeggookItemGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseDomeggookGoodsVo>> {
        if (requestParameters['originalUrl'] == null) {
            throw new runtime.RequiredError(
                'originalUrl',
                'Required parameter "originalUrl" was null or undefined when calling thirdPartProductGetDomeggookItemGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['originalUrl'] != null) {
            queryParameters['originalUrl'] = requestParameters['originalUrl'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/thirdPartProduct/getDomeggookItem`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseDomeggookGoodsVoFromJSON(jsonValue));
    }

    /**
     * 
     * 用url获取domeggook商品，无规格选项的商品（二手/一口价）skus返回单一默认SKU（价格库存取详情页）
     */
    async thirdPartProductGetDomeggookItemGet(requestParameters: ThirdPartProductGetDomeggookItemGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseDomeggookGoodsVo> {
        const response = await this.thirdPartProductGetDomeggookItemGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 用关键词查询地址信息
     */
    async thirdPartProductGetKrAddressGetRaw(requestParameters: ThirdPartProductGetKrAddressGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseKrAddressResultVo>> {
        if (requestParameters['keyword'] == null) {
            throw new runtime.RequiredError(
                'keyword',
                'Required parameter "keyword" was null or undefined when calling thirdPartProductGetKrAddressGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['keyword'] != null) {
            queryParameters['keyword'] = requestParameters['keyword'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/thirdPartProduct/getKrAddress`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseKrAddressResultVoFromJSON(jsonValue));
    }

    /**
     * 
     * 用关键词查询地址信息
     */
    async thirdPartProductGetKrAddressGet(requestParameters: ThirdPartProductGetKrAddressGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseKrAddressResultVo> {
        const response = await this.thirdPartProductGetKrAddressGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 用url获取1688商品
     */
    async thirdPartProductGetTaoBao1688ItemGetRaw(requestParameters: ThirdPartProductGetTaoBao1688ItemGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseTaoBaoProductVo>> {
        if (requestParameters['originalUrl'] == null) {
            throw new runtime.RequiredError(
                'originalUrl',
                'Required parameter "originalUrl" was null or undefined when calling thirdPartProductGetTaoBao1688ItemGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['originalUrl'] != null) {
            queryParameters['originalUrl'] = requestParameters['originalUrl'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/thirdPartProduct/getTaoBao1688Item`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseTaoBaoProductVoFromJSON(jsonValue));
    }

    /**
     * 
     * 用url获取1688商品
     */
    async thirdPartProductGetTaoBao1688ItemGet(requestParameters: ThirdPartProductGetTaoBao1688ItemGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseTaoBaoProductVo> {
        const response = await this.thirdPartProductGetTaoBao1688ItemGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取复制订单商品
     */
    async thirdPartProductGetTaoBaoCopyOrderItemPostRaw(requestParameters: ThirdPartProductGetTaoBaoCopyOrderItemPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListTaoBaoCopyProductVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/thirdPartProduct/getTaoBaoCopyOrderItem`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HtmlWrapperVoToJSON(requestParameters['htmlWrapperVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListTaoBaoCopyProductVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取复制订单商品
     */
    async thirdPartProductGetTaoBaoCopyOrderItemPost(requestParameters: ThirdPartProductGetTaoBaoCopyOrderItemPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListTaoBaoCopyProductVo> {
        const response = await this.thirdPartProductGetTaoBaoCopyOrderItemPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取复制购物车商品
     */
    async thirdPartProductGetTaoBaoCopyShoppingCartHtmlPostRaw(requestParameters: ThirdPartProductGetTaoBaoCopyShoppingCartHtmlPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseListTaoBaoCopyProductVo>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/thirdPartProduct/getTaoBaoCopyShoppingCartHtml`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: HtmlWrapperVoToJSON(requestParameters['htmlWrapperVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseListTaoBaoCopyProductVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取复制购物车商品
     */
    async thirdPartProductGetTaoBaoCopyShoppingCartHtmlPost(requestParameters: ThirdPartProductGetTaoBaoCopyShoppingCartHtmlPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseListTaoBaoCopyProductVo> {
        const response = await this.thirdPartProductGetTaoBaoCopyShoppingCartHtmlPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 用url获取淘宝商品
     */
    async thirdPartProductGetTaoBaoItemGetRaw(requestParameters: ThirdPartProductGetTaoBaoItemGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseTaoBaoProductVo>> {
        if (requestParameters['originalUrl'] == null) {
            throw new runtime.RequiredError(
                'originalUrl',
                'Required parameter "originalUrl" was null or undefined when calling thirdPartProductGetTaoBaoItemGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['originalUrl'] != null) {
            queryParameters['originalUrl'] = requestParameters['originalUrl'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/thirdPartProduct/getTaoBaoItem`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseTaoBaoProductVoFromJSON(jsonValue));
    }

    /**
     * 
     * 用url获取淘宝商品
     */
    async thirdPartProductGetTaoBaoItemGet(requestParameters: ThirdPartProductGetTaoBaoItemGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseTaoBaoProductVo> {
        const response = await this.thirdPartProductGetTaoBaoItemGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 验证个人通关号
     */
    async thirdPartProductVerifyUnipassPersonGetRaw(requestParameters: ThirdPartProductVerifyUnipassPersonGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseVerifyUnipassPersonResVo>> {
        if (requestParameters['persEcm'] == null) {
            throw new runtime.RequiredError(
                'persEcm',
                'Required parameter "persEcm" was null or undefined when calling thirdPartProductVerifyUnipassPersonGet().'
            );
        }

        if (requestParameters['pltxNm'] == null) {
            throw new runtime.RequiredError(
                'pltxNm',
                'Required parameter "pltxNm" was null or undefined when calling thirdPartProductVerifyUnipassPersonGet().'
            );
        }

        if (requestParameters['cralTelno'] == null) {
            throw new runtime.RequiredError(
                'cralTelno',
                'Required parameter "cralTelno" was null or undefined when calling thirdPartProductVerifyUnipassPersonGet().'
            );
        }

        if (requestParameters['zip'] == null) {
            throw new runtime.RequiredError(
                'zip',
                'Required parameter "zip" was null or undefined when calling thirdPartProductVerifyUnipassPersonGet().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['persEcm'] != null) {
            queryParameters['persEcm'] = requestParameters['persEcm'];
        }

        if (requestParameters['pltxNm'] != null) {
            queryParameters['pltxNm'] = requestParameters['pltxNm'];
        }

        if (requestParameters['cralTelno'] != null) {
            queryParameters['cralTelno'] = requestParameters['cralTelno'];
        }

        if (requestParameters['zip'] != null) {
            queryParameters['zip'] = requestParameters['zip'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/thirdPartProduct/verifyUnipassPerson`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseVerifyUnipassPersonResVoFromJSON(jsonValue));
    }

    /**
     * 
     * 验证个人通关号
     */
    async thirdPartProductVerifyUnipassPersonGet(requestParameters: ThirdPartProductVerifyUnipassPersonGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseVerifyUnipassPersonResVo> {
        const response = await this.thirdPartProductVerifyUnipassPersonGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
